



















































import {Component, Watch, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/dialog/DialogMixin';

@Component({
    inheritAttrs: false,
})
export default class ChangePasswordDialog extends Mixins(DialogMixin) {
    private changing: boolean = false;
    private invalidOldPassword: boolean = false;
    private showValidation: boolean = false;

    get invalidOldPasswordMessage() {
        return this.invalidOldPassword ? this.$t('Common.Messages.InvalidPassword') : null;
    }

    get passwordsNotMatch() {
        return this.showValidation ? this.data.newPassword !== this.data.repeatPassword : false;
    }

    get passwordNotMatchMsg() {
        return this.passwordsNotMatch ? this.$t('Common.Messages.PasswordsNotMatch') : null;
    }

    @Watch('data.oldPassword')
    onOldPasswordChange() {
        if (this.invalidOldPassword) this.invalidOldPassword = false;
    }

    async onChange() {
        if (this.invalidOldPassword || this.passwordNotMatchMsg) return;
        const form = this.$refs.form as any;
        if (!this.showValidation) this.showValidation = true;

        const valid = form.validate();
        if (valid && !this.passwordsNotMatch && !this.invalidOldPassword) {
            const timerId = setTimeout(() => (this.changing = true), 100);
            try {
                const {data} = await this.$http.post('/login/ChangePassword', {
                    oldPassword: this.data.oldPassword,
                    newPassword: this.data.newPassword,
                });
                // eslint-disable-next-line no-constant-condition
                if (false) {
                    this.invalidOldPassword = true;
                } else {
                    this.close();
                }
            } catch {
                this.close();
            } finally {
                clearTimeout(timerId);
                if (this.changing) this.changing = false;
            }
        }
    }

    clear() {
        this.showValidation = false;
        (this.$refs.form as any).resetValidation();
    }

    close() {
        this.dialog = false;
        this.options = null;
        setTimeout(() => {
            this.clear();
        }, 175);
    }
}
